import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const productDetailAPI = createApi({
  reducerPath: "productDetailAPI",
  baseQuery: fetchBaseQuery({ baseUrl: BaseUrl,
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
   }),
  endpoints: (builder) => ({
    getProductDetails: builder.query({
      query: (id) => `user/products/product-detail/${id}`,
    }),

    checkVariant: builder.mutation({
      query: (formData) => ({
        url: "check-variant",
        method: "POST",
        body: formData,
      }),
    }),

  }),
});

export const { useGetProductDetailsQuery, useCheckVariantMutation } = productDetailAPI;
